export default function Loading() {
  return (
    <div className="bg-gray-800 h-screen text-center">
      <p className="m-2 text-3xl text-gray-300 animate-pulse">Loading...</p>
    </div>
  );
}
